import { useCallback } from "react";

import type { TTourId } from "@/lib/guidance/types";
import { useStore } from "@/store/store";

export function useTour() {
  const activeTourId = useStore((state) => state.activeTourId);
  const setActiveTourId = useStore((state) => state.setActiveTourId);
  const markTour = useStore((state) => state.markTour);
  const isTourFinished = useStore((state) => state.isTourFinished);

  const startTour = useCallback(
    (tourId: TTourId) => {
      if (isTourFinished(tourId)) {
        return;
      }
      setActiveTourId(tourId);
    },
    [isTourFinished, setActiveTourId]
  );

  const skipTour = useCallback(
    (tourId: TTourId) => {
      markTour(tourId, "dismissed");
    },
    [markTour]
  );

  const completeTour = useCallback(
    (tourId: TTourId) => {
      markTour(tourId, "completed");
    },
    [markTour]
  );

  const stopTour = useCallback(() => {
    setActiveTourId(null);
  }, [setActiveTourId]);

  return {
    activeTourId,
    startTour,
    skipTour,
    completeTour,
    stopTour,
    isTourFinished,
  };
}
